export enum SeverityLevel {
    noHarm = 0,
    low = 1,
    moderate = 2,
    severe = 3,
}

export const SEVERITY_LEVELS = {
    [SeverityLevel.noHarm]: 'No harm',
    [SeverityLevel.low]: 'Low',
    [SeverityLevel.moderate]: 'Moderate',
    [SeverityLevel.severe]: 'Severe',
};

export const SEVERITY_LEVEL_COLOURS = {
    [SeverityLevel.noHarm]: '#757575',
    [SeverityLevel.low]: '#2dc937',
    [SeverityLevel.moderate]: '#e7b416',
    [SeverityLevel.severe]: '#cc3232',
};

export function severityLevelSelectOptions() {
    return Object.keys(SEVERITY_LEVELS).map(key => ({
        label: SEVERITY_LEVELS[key],
        value: +key
    }));
}

export function formatSeverityLevel(value: SeverityLevel) {
    return SEVERITY_LEVELS[value] ?? null;
}
